import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, FlexBox, Page, Tabs } from '@dixa/lib-shared-habla';
import { useMemo } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { DixaMessengerPanel } from './components/DixaMessengerCSAT/Panel';
import styles from './satisfaction.module.scss';
const getTab = (tabId, label, enabled, nudgeUpgrade = false) => {
    if (!enabled && !nudgeUpgrade)
        return null;
    return {
        [tabId]: {
            id: tabId,
            label: (_jsxs(FlexBox, Object.assign({ gap: "100", alignItems: "center" }, { children: [_jsx("span", { children: label }), nudgeUpgrade && !enabled && (_jsx(Badge, Object.assign({ size: "small", variant: "info", className: styles.dixaMessengerBadge }, { children: "Upgrade to access" })))] }))),
        },
    };
};
export const Satisfaction = () => {
    var _a;
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const flags = useFeatureFlag([
        'has-messenger',
        'csat-for-dixa-messenger',
        'csat-for-email',
        'csat-for-widget-chat',
        'csat-for-phone',
    ]);
    const tabs = useMemo(() => (Object.assign(Object.assign(Object.assign(Object.assign({}, getTab('chat', 'Chat', flags.csatForWidgetChat)), getTab('email', 'Email & Forms', flags.csatForEmail)), getTab('messenger', 'Messenger', flags.csatForDixaMessenger, true)), getTab('phone', 'Phone', flags.csatForPhone))), [flags]);
    const tabsToRender = useMemo(() => Object.values(tabs).filter(({ id }) => flags.csatForDixaMessenger ? true : id !== DixaMessengerPanel.PAGE), [flags.csatForDixaMessenger, tabs]);
    // Get the selected tab from the pathname.
    // TODO: This should eventually be replaced by a better route setup with path params.
    const selectedTab = (_a = pathname.match(/^\/settings\/satisfaction\/(\w+)(?:\/.*)?$/)) === null || _a === void 0 ? void 0 : _a[1];
    return (_jsxs(Page, { children: [_jsx(Page.Head, { title: "Satisfaction" }), _jsx(Page.Tabs, { children: _jsx(Tabs, { tabs: tabsToRender, selectedId: selectedTab, onChange: (tabId) => navigate(`/settings/satisfaction/${tabId}`) }) }), _jsx(Page.Body, { children: _jsx(Outlet, {}) })] }));
};
